// extracted by mini-css-extract-plugin
export var orderSummary = "_jk-0";
export var showMoreLessButton = "_jk-1";